@if (!minimalMode) {
<div class="chat-section" [class.showing]="showChat" [ngClass]="{'expanded': showChat}">
  <div class="flex-center-between toggle-chat cursor-pointer" (click)="toggleChat()">
    <div>
      <p class="text-header-16 text-semibold">
        <app-st-icon [bold]="true" name="chat_bubble"></app-st-icon>
        Mensajes
        @if (chatName && showChat) {
          <span class="text-label-16 text-semibold">({{ chatName }})</span>
        }
      </p>
      @if (!showChat && unreadedMessages > 0) {
        <div style="align-items: center" class="flex">
          <div style="margin-left: 0" class="status-dot-wrapper">
            <div class="status-dot info"></div>
          </div>
          <p class="text-label-14">{{ unreadedMessages }} mensajes nuevos</p>
        </div>
      }
    </div>
    <app-st-icon style="font-size: 24px" [name]="showChat ? 'close' : 'keyboard_arrow_up'"></app-st-icon>
  </div>

  <!-- Contenido del chat (se muestra solo si está expandido) -->
  @if (showChat) {
    <div class="chat-content">
      <div #messageContainer class="chat-messages flex-column"
           [ngClass]="!chat?.chatMessages?.length ? 'flex-center' : 'flex gap-300'">

        @if (chat && chat.chatMessages && chat.chatMessages.length > 0) {
          <!--   Cuando el chat NO esta vacio   -->
            <!--   Lista de mesajes   -->
          @for (msg of chat.chatMessages; let i = $index; track msg.id) {
            @if (unreadIndex !== undefined && i === unreadIndex) {
              <nz-divider #divider class="new-msg-divider"
                          [nzText]="instantMessagesUnread + ' mensajes nuevos'"></nz-divider>
            }
            <nz-comment appMarkAsRead (visible)="markAsRead(msg)"
                        [ngClass]="msg.user.id === this.loggedUser!.id ? 'self-msg' : ''"
                        [nzAuthor]="msg.user.id === this.loggedUser!.id ? 'Tú' : msg.partner.name + (msg.partner.surName ? ' ' + msg.partner.surName : '')"
                        [nzDatetime]="msg.createdOn | relativeDate">
              <nz-avatar class="not-max-width" nz-comment-avatar nzIcon="user"
                         [nzSrc]="getSafeImageUrl(msg.partner.avatar) || ''"></nz-avatar>
              <nz-comment-content>
                <p [innerHTML]="highlightMentions(msg.message | mentionTransform:users)"></p>
                @for (doc of msg.documents; track doc.id) {
                  <app-doc-badget-status [document]="doc" [showName]="true" [ignoreExpiration]="true"></app-doc-badget-status>
                }
              </nz-comment-content>
            </nz-comment>
          }

        } @else {
          <!--   Cuando el chat esta vacio   -->
          <app-st-icon style="color: #C9C9C9; font-size: 120px" name="forum"></app-st-icon>
          <span class="text-header-24 main-text">
            Empieza una conversación en "{{ chatName }}"
          </span>
          <span style="text-align: center; max-width: 365px; line-height: 21px" class="text-label-14">
            Colabora con los agentes involucrados, coordina detalles de los proyectos o confirma acuerdos para la ejecución de los servicios.
          </span>
        }
      </div>

      @if (createdDocuments.length > 0) {
        <div class="folders-msg-feedback">
          <div>
            <app-st-icon class="avatar" [avatar]="true" name="task"></app-st-icon>

            <span>{{ createdDocuments.length }} archivo{{ createdDocuments.length > 1 ? 's' : null }}
              adjunto{{ createdDocuments.length > 1 ? 's' : null }}</span>

            <app-st-icon class="close" (click)="createdDocuments = []" name="close"></app-st-icon>
          </div>
        </div>
      }

      <div class="flex gap-100 chat-input-wrapper">
        <nz-mention (nzOnSelect)="mentionSelectionChange($event)" (nzOnSearchChange)="mentionSearchChange()"
                    [nzNotFoundContent]="'No hay usuarios con esas especificaciones'"
                    [nzSuggestions]="users" [nzValueWith]="valueWith" nzPlacement="top">
          <nz-input-group class="chat-input-group" nzSize="large" [nzAddOnAfter]="sendTmpl">
            <textarea nz-input [(ngModel)]="inputValue"
                      (keydown.enter)="(!sendingMsg && inputValue && !isMentioning) ? send($event) : null"
                      [nzAutosize]="true" class="chat-input" nzMentionTrigger
                      [ngClass]="inputValue ? '' : 'empty'"
                      [placeholder]="'Escribe un comentario en “' + chatName + '”.' + (isLarge ? ' Usa @ para mencionar a alguien...' : '')"></textarea>
          </nz-input-group>

          <ng-container *nzMentionSuggestion="let user">
            <nz-avatar style="margin-right: 12px" nzSize="small" [nzText]="user.email" class="not-max-width"
                       [nzSrc]="getSafeImageUrl(user.partner?.avatar)"></nz-avatar>
            <span>{{ user.partner.name || '.' }} - {{ user.partner.surName || '.' }}</span>
          </ng-container>
        </nz-mention>
        <ng-template #sendTmpl>
          <div (click)="(!sendingMsg && inputValue) ? send($event) : null"
               [class.cursor-pointer]="!!inputValue"
               class="h-100 send-tmpl">
            @if (!sendingMsg) {
              <app-st-icon style="font-size: 24px" [bold]="true" color='#171717' name="send"></app-st-icon>
            }
            @if (sendingMsg) {
              <app-st-icon style="font-size: 24px" [bold]="true" name="progress_activity"></app-st-icon>
            }
          </div>
        </ng-template>

        @if (!!authService.loggedUser$.value?.uploadDocumentsUnlimited || !!authService.loggedUser$.value?.uploadDocumentsLimited) {
          <button
                  (click)="openUploadDocsModal()"
                  style="min-width: 43px; min-height: 43px; padding: 0"
                  class="text-btn-16 larger" nz-button nzType="default" nzSize="large" nzShape="circle">
            <app-st-icon name="attach_file" color="#1C1B1F" [bold]="true"></app-st-icon>
          </button>
        }
      </div>
    </div>
  }
</div>
}

<!-- Botón para sidebar colapsado -->
@if (minimalMode) {
<button (click)="openChatSidebar()" class="minimal-chat-btn" nz-button nzShape="circle" nzType="text" nzSize="small">
  @if (!unreadedMessages) {
    <app-st-icon style="position: absolute; left: 4px;" [bold]="true" name="chat_bubble"></app-st-icon>
  }
  @if (unreadedMessages) {
    <app-st-icon style="position: absolute; left: 4px;" [bold]="true" name="mark_chat_unread"></app-st-icon>
  }
  @if (unreadedMessages) {
    <nz-badge  class="blue collapse-message-dot" nzStandalone [nzDot]="unreadedMessages" [nzOffset]="[1, -6]"></nz-badge>
  }
</button>
}

<button (click)="toggleChat()" class="mobile-chat-btn" nz-button nzShape="circle" nzType="text" nzSize="small">
  <app-st-icon style="position: absolute; left: 4px;" [bold]="true" name="chat_bubble"></app-st-icon>
  @if (unreadedMessages) {
    <nz-badge class="blue" nzStandalone [nzDot]="true" [nzOffset]="[3, -6.5]"></nz-badge>
  }
</button>
